import { render, staticRenderFns } from "./SearchCard.vue?vue&type=template&id=c153da42&scoped=true"
import script from "./SearchCard.vue?vue&type=script&lang=js"
export * from "./SearchCard.vue?vue&type=script&lang=js"
import style0 from "./SearchCard.vue?vue&type=style&index=0&id=c153da42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c153da42",
  null
  
)

export default component.exports